<template>
    <div class="app-calendar overflow-hidden ">
        <div cols="12" md="12" class="d-block d-md-none">
            <b-card>
                <v-select v-model="filter.staff_id" :options="staffOptions" :clearable="false" :filterable="true"
                    input-id="package" :reduce="option => option.id"></v-select>
                <v-select class="mt-1" v-model="filter.rooms" :options="rooms" multiple :clearable="false"
                    :filterable="true" input-id="package" :reduce="option => option.id"></v-select>
            </b-card>
        </div>
        <div class="row no-gutters">
            <!-- Sidebar -->
            <div class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
                :class="{'show': isCalendarOverlaySidebarActive}">
                <calendar-sidebar :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive" @fetch="test" />
            </div>

            <!-- Calendar -->
            <div class="col position-relative">
                <div class="card shadow-none border-0 mb-0 rounded-0">
                    <div class="card-body pb-0">
                        <full-calendar ref="refCalendar" :options="calendarOptions" class="full-calendar" />
                    </div>
                </div>
            </div>

            <!-- Sidebar Overlay -->
            <div class="body-content-overlay" :class="{'show': isCalendarOverlaySidebarActive}"
                @click="isCalendarOverlaySidebarActive = false" />

            <calendar-event-handler v-model="isEventHandlerSidebarActive"
                :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive" :room-options="rooms"
                :booking-data="bookingData" @hidden="isEventHandlerSidebarActive=false;get_booking('','')" />
            <calendar-event-handler-update v-model="isEventHandlerSidebarUpdateActive"
                :is-event-handler-sidebar-active-update.sync="isEventHandlerSidebarUpdateActive" :room-options="rooms"
                :booking-data="bookingData" @hidden="isEventHandlerSidebarUpdateActive=false;get_booking('','')"
                @change_end="change_end_now" />

        </div>
    </div>
</template>

<script>
    import {
        BCard
    } from 'bootstrap-vue'
    import FullCalendar from '@fullcalendar/vue'
    import CalendarSidebar from './calendar-sidebar/CalendarSidebar.vue'
    import CalendarEventHandler from './calendar-event-handler/CalendarEventHandler.vue'
    import CalendarEventHandlerUpdate from './calendar-event-handler/CalendarEventHandlerUpdate.vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import listPlugin from '@fullcalendar/list'
    import interactionPlugin from '@fullcalendar/interaction'
    import vSelect from 'vue-select'

    export default {
        components: {
            FullCalendar, // make the <FullCalendar> tag available
            CalendarSidebar,
            vSelect,
            BCard,
            CalendarEventHandler,
            CalendarEventHandlerUpdate,
        },
        watch: {
            'filter.staff_id': {
                handler(newValue, oldValue) {
                    this.test(this.filter.rooms, newValue)
                }
            },
            'filter.rooms': {
                handler(newValue, oldValue) {
                    this.test(newValue, this.filter.staff_id)
                }
            },
        },
        data() {
            return {
                selected_rooms: null,
                filter: {
                    staff_id: null,
                    rooms: []
                },
                isCalendarOverlaySidebarActive: false,
                isEventHandlerSidebarUpdateActive: false,
                rooms: [],
                staffOptions: [],
                selected_user_id: null,
                user_id: null,
                bookingData: {
                    end_at: null,
                    start_at: null,
                    room_id: null,
                    user_id: null
                },
                isEventHandlerSidebarActive: false,
                calendarOptions: {
                    eventSources: [
                        (fetchInfo, successCallback, failureCallback) => {
                            const token = JSON.parse(localStorage.getItem('userData')).token
                            const centerId = this.$store.getters['center/currentCenterId']
                            const userId = this.selected_user_id ?? 'all'
                            const selectedRoom = this.selected_rooms ?? 'all'
                            const start = encodeURIComponent(fetchInfo.startStr)
                            const end = encodeURIComponent(fetchInfo.endStr)
                            const url = `${process.env.VUE_APP_API_BASE}/center/${centerId}/booking_v2/?token=${token}&start=${start}&end=${end}&user_id=${userId}&rooms=${selectedRoom}`
                            fetch(url)
                                .then(response => response.json())
                                .then(data => {
                                    successCallback(data)
                                })
                                .catch(error => {
                                    failureCallback(error)
                                })
                        }
                    ],
                    // eventSources: [
                    // { url: process.env.VUE_APP_API_BASE+`/center/`+this.$store.getters['center/currentCenterId']+'/booking_v2/?token='+JSON.parse(localStorage.getItem('userData')).token }
                    // ],
                    eventDidMount: function (info) {
                        if (JSON.parse(localStorage.getItem('userData')).config.booking_attend_color !== null) {
                            if (info.event._def.extendedProps.is_attend == "Y") {
                                info.el.style = 'background-color:#' + JSON.parse(localStorage.getItem('userData'))
                                    .config.booking_attend_color + ' !important'
                            }
                        }

                    },
                    slotEventOverlap: false,
                    lazyFetching: false,
                    titleFormat: {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    },
                    views: {
                        timeGridWeek: { // name of view
                            titleFormat: {
                                year: 'numeric',
                                month: 'long',
                                day: '2-digit'
                            }
                        },
                        timeGrid: {
                            titleFormat: {
                                year: 'numeric',
                                month: 'long',
                                day: '2-digit'
                            }
                        },
                        week: {
                            titleFormat: {
                                year: 'numeric',
                                month: 'long',
                                day: '2-digit'
                            }
                        },
                        // 新增 One Day List View
          listDay: {
            type: 'list',
            duration: { days: 1 }, // 限制為單天
            titleFormat: {
              year: 'numeric',
              month: 'long',
              day: '2-digit'
            },
            listDayFormat: { // 控制事件列表的日期格式
              weekday: 'long',
              month: 'long',
              day: '2-digit',
              year: 'numeric'
            }
          }
 
                    },
                    firstDay: JSON.parse(localStorage.getItem('userData')).config.calendar_first_day,
                    allDaySlot: false,
                    scrollTime: JSON.parse(localStorage.getItem('userData')).config.slot_min_time,
                    slotMinTime: JSON.parse(localStorage.getItem('userData')).config.slot_min_time,
                    slotMaxTime: JSON.parse(localStorage.getItem('userData')).config.slot_max_time,
                    plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
                    initialView: 'listDay',
                    headerToolbar: {
                        start: 'sidebarToggle, prev,next, title',
                        end: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth,listDay',
                    },
                    buttonText: {
                     listDay: 'Day - list' ,
                     timeGridDay: 'Day - Grid',
                    },
                    customButtons: {
                        sidebarToggle: {
                            // --- This dummy text actual icon rendering is handled using SCSS ----- //
                            text: 'Add',
                            click: (event) => {
                                this.isEventHandlerSidebarActive = true
                            },
                        },
                    },
                    events: [],
                    eventClick: (event) => {
                        this.showEvent(event)
                    },

                    isEventHandlerSidebarActive: false
                }
            }
        },
        created() {
            this.get_staff()
            this.get_room()
        },
        methods: {
            get_room() {
                this.$http.get(process.env.VUE_APP_API_BASE+`/rooms/?enabled=y&center_id=`+ this.$store.getters['center/currentCenterId'])
                    .then(res => {
                    if (process.env.VUE_APP_VERSION != res.data.version) {
                        this.$router.go(0);
                    }
                    this.rooms = res.data.rooms
                    })
                },
            get_staff() {
                this.$http.get(process.env.VUE_APP_API_BASE + `/staffs/?staff&perpage=9999&page=1&onlyactive=true`)
                    .then(res => {
                        this.staffOptions = res.data.staffs
                        //  console.log(this.staffOptions)
                    })
            },
            change_end_now(val) {
                //  console.log(val)
                this.bookingData.end_at = val
            },
            test(rooms, staff) {
                this.selected_user_id = staff
                this.selected_rooms = rooms.join(',')
                this.get_booking(rooms.join(','), this.user_id)
            },
            get_booking(room_array, user_id) {
                let calendar = this.$refs.refCalendar.getApi()
                calendar.refetchEvents()

            },
            showEvent(data) {
                this.bookingData = data.event._def.extendedProps
                //  console.log(this.bookingData)
                this.isEventHandlerSidebarUpdateActive = true
                // console.log(this.isEventHandlerSidebarActive)
            }
        }
    }
</script>

<style lang="scss">
    @import"@core/scss/vue/apps/calendar.scss";
</style>